import React from 'react'
import IconListItem from './IconListItem'
import UploadButton from './UploadButton'
import ReceiptViewHeader from 'steps/receipt/components/ReceiptViewHeader'
import './HowItWorksView.scss'

const HowItWorksView = ({
  onUploadError,
  themeColors,
  handleFileSelection,
  setPosition,
  headline,
  introCopy,
  headerImage,
  instructions = [],
  userPathHeadline,
  iconBackgroundClr,
  iconBorderClr,
  openUploadModal = function () {},
  skipReceipt = function () {},
}) => {
  const { primaryCopyColor, primaryColorButtons } = themeColors
  //respect order properties in beaker.config.js
  const sortedInstructions = instructions.sort(
    (a, b) => a.displayOrder - b.displayOrder,
  )
  return (
    <div className="receipt-view how-it-works-view">
      <ReceiptViewHeader
        headline={headline}
        introCopy={introCopy}
        headerImage={headerImage}
      />
      <div className={`receipt-view-content`}>
        {instructions && (
          <ul className={`how-it-works-list`}>
            {sortedInstructions.map((instruction, index) => {
              return (
                <IconListItem
                  key={index}
                  {...instruction}
                  iconBackgroundClr={'#FFFFFF'}
                  iconBorderClr={primaryCopyColor}
                />
              )
            })}
          </ul>
        )}
      </div>
      {userPathHeadline && (
        <h3
          className="receipt-path-headline"
          dangerouslySetInnerHTML={{ __html: userPathHeadline }}
        />
      )}
      <div className={`receipt-button-container`}>
        <button
          className="btn themed-button-secondary"
          onClick={() => {
            setPosition(3)
          }}
        >
          Not Yet
        </button>
        <UploadButton
          onFileSelection={handleFileSelection}
          maxFiles={1}
          label={`Upload Photo or Video`}
          onError={onUploadError}
          className="btn themed-button"
        />
      </div>
    </div>
  )
}
export default HowItWorksView
